<template>
  <div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class="users-manage">
      <div class="menu-title">
        <div class="menu-right" data-app="true">
          <!--  -->
          <div class="filter-container" @click="filterClick">
            <CDNButton
              :BtnText="$t('common.filter')"
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_filter.png')"
            />
            <CDNButton
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_down.png')"
              innerstyle="margin-left: 5px; margin-right: 10px"
            />
          </div>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div class="filter-container" v-bind="attrs" v-on="on">
                <CDNButton
                  :BtnText="$t('common.BatchOper')"
                  :imgPath="require('@/assets/images/products/icon_filter.png')"
                />
                <CDNButton
                  :imgPath="require('@/assets/images/products/icon_down.png')"
                  innerstyle="margin-left: 5px;"
                />
              </div>
            </template>

            <v-list>
              <v-list-item v-for="(item, i) in items" :key="i">
                <div
                  @click="domainClick(item.value)"
                  style="
                    cursor: pointer;
                    font-family: PingFangSC-Semibold;
                    font-size: 14px;
                    color: #131523;
                  "
                >
                  {{ item.title }}
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
          <CDNButton
            :BtnText="$t('common.refresh')"
            :imgPath="require('@/assets/images/products/icon_refresh.png')"
            innerstyle="margin-left: 24px;"
            @btnclick="refresh"
          />

          <CDNButton
            :BtnText="$t('allDomain.addRootDomain')"
            :imgPath="require('@/assets/images/domain/icon_domain.png')"
            innerstyle="margin-left: 24px;"
            @btnclick="showaddRootDomainDiag = true"
          />
        </div>
      </div>
      <div class="input-container" v-show="isFilter">
        <loginInput
          :label="$t('allDomain.domain')"
          :appendIcon="require('@/assets/images/products/prod_icon_user.png')"
          inputStyle="width: 288px;"
          realInputStyle="width: 288px;"
          @changeInput="(e) => (searchDomain = e)"
          :inputValue="searchDomain"
        />
        <CDNDatePicker
          ref="createdate"
          :label="$t('allDomain.createDate')"
          innerStyle="width: 288px; margin-left: 24px;"
          @changeDate="(date) => (createDate = date)"
          type="daterange"
        />
      </div>

      <div class="search-btn-content" v-show="isFilter">
        <CDNButton
          :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
        />
        <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
        />
      </div>

      <!-- 列表 -->
      <el-table
       :data="tableData"
       height="500"
        style="width: 100%"
    @selection-change="selectedRows">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
        <el-table-column
          align="center"
          :label="$t('allDomain.mainDomain')"
        >
        <template slot-scope="scope">
          <div
            style="cursor: pointer;"
              
                @click="
                  $router.push({
                    name: 'subdomains',
                    params: { id: scope.row.id },
                  })
                "
          >
            {{ scope.row.sub_host }}
          </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="merchatProduct"
          :label="$t('allDomain.products')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="statesName"
          :label="$t('allDomain.status')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="wildcard_ssl"
          :label="`*${$t('allDomain.cert')}`"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="subhost_ssl"
          :label="`@${$t('allDomain.cert')}`"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          :label="$t('allDomain.createDate')"
        >
        </el-table-column>
        <el-table-column
         align="center" :label="$t('product.handle')">
          <template slot-scope="scope">

       <div>
            
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('allDomain.config')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="success"
                @click="
                  $router.push({
                    name: 'domain_settings',
                    params: { id: scope.row.id },
                  })
                "
                  icon="el-icon-s-tools"
                  circle
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.Statistics')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="warning"
                @click="
                  $router.push({
                    name: 'domain_static',
                    params: { id: scope.row.id },
                  })
                "
                  icon="el-icon-s-data"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.delete')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteClick(scope.row)"
                  icon="el-icon-delete"
                  circle
                ></el-button>
              </el-tooltip>
              
              <!-- <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.childDomain')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  
                @click="
                  $router.push({
                    name: 'subdomains',
                    params: { id: scope.row.id },
                  })
                "
                  icon="el-icon-edit"
                  circle
                ></el-button>
              </el-tooltip> -->
          </div>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      
      <div class="pagination-bottom">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>
      <!-- 列表 -->
    </div>
    <!-- 删除 -->
    <el-dialog
      :title="$t('allDomain.passwordAuth')"
      :visible.sync="showpasswordDiag"
      width="532px"
    >
      <div class="dialog-content">
        <loginInput
          inputStyle="margin-bottom: 10px;"
          realInputStyle="height: 40px;"
          @changeInput="(e) => (certPassword = e)"
          type="password"
        />
        <div class="btn-content">
          <div @click="commitDels">{{ $t("allDomain.confirm") }}</div>
          <div @click="showpasswordDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 清理缓存 -->
    <el-dialog
      :title="$t('allDomain.cleanCache')"
      :visible.sync="showcleanCacheDiag"
      width="532px"
    >
      <div class="dialog-content">
        <div class="diag-tip">
          <p>{{ $t("allDomain.cleanTip") }}</p>
        </div>
        <div class="btn-content">
          <div @click="commitClean">{{ $t("allDomain.confirm") }}</div>
          <div @click="showcleanCacheDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 批量设置防御 -->
    <el-dialog
      :title="$t('allDomain.SetDefense')"
      :visible.sync="showSetDefenseDiag"
      width="532px"
    >
      <div class="dialog-content">
        <CDNSwitch
          :label="$t('allDomain.ShieldingUA')"
          :hasbottomline="false"
          :inValue="isBanEmptyUA"
          @change="(e) => (isBanEmptyUA = e)"
        />

        <CDNSwitch
          :label="$t('allDomain.JSShield')"
          :hasbottomline="false"
          :inValue="jsGuard"
          @change="(e) => (jsGuard = e)"
        />

        <CDNSwitch
          :label="$t('allDomain.VerificationCode')"
          :hasbottomline="false"
          :inValue="useCaptcha"
          @change="(e) => (useCaptcha = e)"
        />
        <!--  -->
        <div class="btn-content">
          <div @click="batchUpdate('defenses')">
            {{ $t("allDomain.confirm") }}
          </div>
          <div @click="showSetDefenseDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 强制跳转 -->
    <el-dialog
      :title="$t('allDomain.BatchforceJump')"
      :visible.sync="showforceRedictDiag"
      width="532px"
    >
      <div class="dialog-content">
        <CDNSwitch
          :label="$t('allDomain.forceJump')"
          :hasbottomline="false"
          :inValue="lockHttps"
          @change="(e) => (lockHttps = e)"
        />
        <!--  -->
        <div class="btn-content">
          <div @click="batchUpdate('lockHttps')">
            {{ $t("allDomain.confirm") }}
          </div>
          <div @click="showforceRedictDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 申请证书 -->

    <el-dialog
      :title="$t('allDomain.applyCert')"
      :visible.sync="showAplyCertDiag"
      width="532px"
    >
      <div class="dialog-content">
        <CDNRadios :hasLine="false" v-model="ssltype" :items="ssltypeItems" />
        <div class="diag-tip">
          <p>{{ $t("allDomain.applyTip1") }}</p>
          <p>{{ $t("allDomain.applyTip2") }}</p>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitApplyCert">{{ $t("allDomain.confirm") }}</div>
          <div @click="showAplyCertDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!--  -->
    <el-dialog
      :title="$t('allDomain.originOper')"
      :visible.sync="showOriginDiag"
      width="532px"
    >
      <div class="dialog-content">
        <!-- <CDNRadios
          :hasLine="false"
          v-model="ssltype"
          :items="ssltypeItems"
        /> -->
        <div class="lan-dong">
          <span class="text-gray-style">*{{ $t("allDomain.originSite") }}</span>

          <CDNRadios
            v-model="upstream_opt"
            :items="originitems"
            :hasLine="false"
          />
          <div>
            <el-input
              type="textarea"
              :rows="5"
              placeholder="11.22.33.44:80s"
              v-model="upstreamsTextarea"
            >
            </el-input>
            <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
              {{$t('allDomain.tip1')}}
            </div>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitOrigin">{{ $t("allDomain.confirm") }}</div>
          <div @click="showOriginDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 添加根域名 -->
    <el-dialog
      :title="$t('allDomain.addRootDomain')"
      :visible.sync="showaddRootDomainDiag"
      width="532px"
    >
      <div class="dialog-content">
        <ElementSelect
          :label="$t('allDomain.products')"
          :options="userSelectsOptions"
          @selectValue="(e) => (selectProdId = e)"
        />
        <div class="lan-dong">
          <span class="text-gray-style">
            *{{ `${$t("allDomain.rootDomain")}` }}</span
          >
          <div style="margin-top: 24px">
            <el-input
              type="textarea"
              :rows="5"
              @input="toChangeRootDomain"
              :placeholder="
                $i18n.locale == 'en_US'
                  ? 'You can add multiple domain names, separated by |'
                  : '可添加多个域名，用|隔开'
              "
              v-model="rootDomaintextarea"
            >
            </el-input>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitAddRootDomain">{{ $t("allDomain.confirm") }}</div>
          <div @click="showaddRootDomainDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('allDomain.addsubdomain')"
      :visible.sync="showAddSubdomainDiag"
      width="532px"
    >
      <div class="dialog-content">
        <div class="lan-dong">
          <span class="text-gray-style">*{{ $t("allDomain.mainDomain") }}</span>

          <div style="margin-top: 24px">
            <el-input
              type="text"
              disabled
              placeholder=""
              v-model="subhostsTextarea"
            >
            </el-input>
          </div>
        </div>
        <div class="lan-dong">
          <span class="text-gray-style">
            *{{
              `${$t("product.childDomain")} ${$t("allDomain.originSite")}`
            }}</span
          >
          <div style="margin-top: 24px">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="aaa 11.22.33.44:80s"
              v-model="upstreamTextarea"
            >
            </el-input>
            <div>{{ $t("allDomain.upstreamTip") }}</div>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitAddSubdomain">{{ $t("allDomain.confirm") }}</div>
          <div @click="showAddSubdomainDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 上传证书 -->

    <el-dialog
      :title="$t('allDomain.submitCerts')"
      :visible.sync="showSubmitCertsDiag"
      width="80%"
    >
      <div class="dialog-content">
        <div class="lan-dong">
          <span class="text-gray-style">{{$t('allDomain.mainDomain')}}</span>

          <div style="margin-top: 24px">
            <el-input type="textarea" :rows="5" v-model="subhosts"> </el-input>
            <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
              {{$t('allDomain.tip2')}}
            </div>
          </div>
        </div>
        <CDNRadios :hasLine="false" v-model="ssl_type" :items="ssl_typeItems" />
        <div class="lan-dong">
          <span class="text-gray-style">{{$t('allDomain.certContent')}}</span>

          <div style="margin-top: 24px">
            <el-input type="textarea" :rows="5" v-model="certContent">
            </el-input>
            <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
              {{$t('allDomain.tip44')}}
            </div>
            <input
            style="display: none;"
              type="file"
              accept="*/*"
              @change="(e) => uploadImg(e, 'certContent')"
              ref="uploaderImg1"
            />
            <div class="select-my-file" @click="$refs.uploaderImg1.click()">select file</div>
          </div>
        </div>

        <div class="lan-dong">
          <span class="text-gray-style">{{$t('allDomain.tip55')}}</span>
          <div style="margin-top: 24px">
            <el-input type="textarea" :rows="5" v-model="syContent"> </el-input>
            <div style="margin-bottom: 15px; color: #666666; font-size: 14px">
              {{$t('allDomain.tip44')}}
            </div>

            <input
            style="display: none;"
              type="file"
              accept="*/*"
              @change="(e) => uploadImg(e, 'syContent')"
              ref="uploaderImg2"
            />
            
            <div class="select-my-file" @click="$refs.uploaderImg2.click()">select file</div>
          </div>
        </div>

        <div class="btn-content">
          <div @click="commitSubmitCerts">{{ $t("allDomain.confirm") }}</div>
          <div @click="showSubmitCertsDiag = false">
            {{ $t("allDomain.cancel") }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import domainSetting from "@/views/domain/domainSetting.vue";
import {
  mainDomainList,
  productList,
  addMainDomain,
  apiSubhostBatchEdit,
  apiSubhostDelete,
  configMainCn,
  apiSubhostApplyCert,
  addNewChildDomain,
  apiSubmitCerts,
  uploadCertFile,
} from "@/service/requestRes";
import { upstream_str2list_domain, upstream_str2list } from "@/utils/upstreams";

export default {
  components: {
    domainSetting,
  },
  data() {
    return {
      isFilter: false,
      addUseShow: false,
      showOriginDiag: false,
      showAplyCertDiag: false,
      showforceRedictDiag: false,
      showSetDefenseDiag: false,
      showcleanCacheDiag: false,
      showpasswordDiag: false,
      showaddRootDomainDiag: false,
      showAddSubdomainDiag: false,
      showSubmitCertsDiag: false,
      certPassword: "",
      searchDomain: "",
      createDate: "",
      tableData: [],
      upstreamsTextarea: "",
      upstream_opt: 1,
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
      originRadios: 1,
      userSelectsOptions: [],
      selectProdId: "",
      rootDomaintextarea: "",
      clickSelectItem: {},
      lockHttps: null,
      isBanEmptyUA: null,
      jsGuard: null,
      useCaptcha: null,
      ssltype: null,
      subhostsTextarea: "",
      subhosts: "",
      upstreamTextarea: "",
      certContent: "",
      syContent: "",
      ssl_type: 0,
    };
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t("allDomain.mainDomain"), value: "sub_host" },
        { label: this.$t("allDomain.products"), value: "merchatProduct" },
        { label: this.$t("allDomain.status"), value: "statesName" },
        { label: `*${this.$t("allDomain.cert")}`, value: "wildcard_ssl" },
        { label: `@${this.$t("allDomain.cert")}`, value: "subhost_ssl" },
        { label: this.$t("allDomain.createDate"), value: "created_at" },
        { label: this.$t("product.handle"), value: "handle" },
      ];
    },
    originitems() {
      return [
        {
          label: this.$t("allDomain.originSettings"),
          value: 1,
        },
        {
          label: this.$t("allDomain.originSiteAdd"),
          value: 2,
        },
      ];
    },
    ssltypeItems() {
      return [
        {
          label: this.$t("settings.ssltype1"),
          value: 1,
        },
        {
          label: this.$t("settings.ssltype2"),
          value: 2,
        },
      ];
    },
    ssl_typeItems() {
      return [
        { label: this.$t("settings.ssl_type0"), value: 0 },
        { label: this.$t("settings.ssl_type1"), value: 1 },
        { label: this.$t("settings.ssl_type2"), value: 2 },
        { label: this.$t("settings.ssl_type3"), value: 3 },
        { label: this.$t("settings.ssl_type4"), value: 4 },
        { label: this.$t("settings.ssl_type5"), value: 5 },
      ];
    },
    applyCertItems() {
      return [
        {
          label: `@${$t("certManage.cert")}`,
          value: 1,
        },
        {
          label: `*${$t("certManage.cert")}`,
          value: 2,
        },
      ];
    },
    tabs() {
      return [this.$t("allDomain.DomainNames")];
    },
    items() {
      return [
        { title: this.$t("allDomain.originSettings"), value: 1 },
        { title: this.$t("allDomain.applyCert"), value: 2 },
        { title: this.$t("allDomain.forceJump"), value: 3 },
        { title: this.$t("allDomain.DefenseStrategy"), value: 4 },
        { title: this.$t("allDomain.cleanCache"), value: 5 },
        { title: this.$t("allDomain.delete"), value: 6 },
        { title: this.$t("allDomain.addsubdomain"), value: 7 },
        { title: this.$t("allDomain.submitCerts"), value: 8 },
      ];
    },
  },
  mounted() {
    const { pid } = this.$route.query || {};
    this.getmainDomainList({ page: 1, pid });
    this.getAllProductList({ page: 1 });
  },

  watch: {
    "$i18n.locale": function (e) {
      this.getmainDomainList({ page: 1, isEn: e == "en_US" });
    },
  },
  methods: {
    toChangeRootDomain(e) {
      let res = e.replace(/\r\n/g, "|");
      res = res.replace(/\r/g, "|");
      res = res.replace(/\n/g, "|");
      res = res.replace(/,{2,}/g, "|");
      this.rootDomaintextarea = res;
    },
    uploadImg(e, type) {
      var file = e.target.files[0];
      var formData = new FormData();
      formData.append("file", file);
      this.uploadFile(formData, type);
    },
    uploadFile(formData, type) {
      uploadCertFile(formData).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          if (type == "certContent") {
            this.certContent = data;
          } else {
            this.syContent = data;
          }
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    getAllProductList({ page }) {
      productList({
        page,
        limit: 100,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.userSelectsOptions =
            list.data &&
            list.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
        }
      });
    },
    getmainDomainList({
      page,
      start_date,
      end_date,
      pid,
      sub_host,
      states,
      isEn,
    }) {
      mainDomainList({
        page,
        limit: this.pageSize,
        start_date,
        end_date,
        sub_host,
        pid,
        states,
      }).then((res) => {
        const { data, code, msg } = res || {};
        const ab = {
          正常: "Normal",
          到期: "Expire",
          申请中: "Applying",
          无: "None",
        };
        const { locale } = this.$i18n;
        const flag = locale === "en_US" || isEn;
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.tableData =
            list.data &&
            list.data.map((item) => {
              return {
                ...item,
                merchatProduct: item.merchat_product.name,
                subhost_ssl: flag ? ab[item.subhost_ssl] : item.subhost_ssl,
                wildcard_ssl: flag ? ab[item.wildcard_ssl] : item.wildcard_ssl,
                statesName:
                  item.states === 1
                    ? (flag && "Enabled") || "启用"
                    : (flag && "Disable") || "禁用",
              };
            });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    handleChange(e) {
      console.log("pagination", e);
      this.getmainDomainList({ page: e });
    },
    selectedRows(items) {
      this.selectItems = items;
      let subhosts = this.selectItems.map((item) => item.sub_host);
      this.subhostsTextarea = subhosts.join("|");
    },
    commitApplyCert() {
      this.selectItems.forEach((item) => {
        apiSubhostApplyCert({
          subhost: item.sub_host,
          ssltype: this.ssltype,
        }).then((res) => {
          const { data, code, msg } = res || {};
          if (code === 1) {
            this.$message({
              message: item.sub_host + ": " + this.$t("common.success"),
              type: "success",
            });
          } else {
            this.$message({
              message: item.sub_host + ": " + msg,
              type: "error",
            });
          }
        });
      });
      this.showAplyCertDiag = false;
    },
    commitSubmitCerts() {
      if (!this.subhosts) {
        this.$message({ message: "请输入主域名", type: "warn" });
        return;
      }
      if (!this.certContent) {
        this.$message({ message: "请输入证书内容", type: "warn" });
        return;
      }
      if (!this.syContent) {
        this.$message({ message: "请输入证书秘钥", type: "warn" });
        return;
      }
      apiSubmitCerts({
        ssl_cert: this.certContent,
        ssl_key: this.syContent,
        subhosts: this.selectItems.map((item) => item.sub_host),
        ssl_type: this.ssl_type,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t("common.success"),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });

      this.certContent = "";
      this.syContent = "";
      this.ssl_type = 0;
      this.showSubmitCertsDiag = false;
    },
    commitOrigin() {
      // batch
      // alert(this.selectItems);
      this.batchUpdate(
        this.upstream_opt == 1 ? "upstreams_sets" : "upstreams_adds"
      );
      // console.log(this.selectItems.map(item => item.sub_host));
      this.showOriginDiag = false;
    },
    commitClean() {
      this.selectItems.forEach((item) => {
        configMainCn({ func: "pureCache", subhost: item.sub_host }).then(
          (res) => {
            const { data, code, msg } = res || {};
            if (code === 1) {
              this.$message({
                message: item.sub_host + ": " + this.$t("common.success"),
                type: "success",
              });
            } else {
              this.$message({
                message: item.sub_host + ": " + msg,
                type: "error",
              });
            }
          }
        );
      });
      this.showcleanCacheDiag = false;
    },
    commitDels() {
      this.selectItems.forEach((item) => {
        apiSubhostDelete({
          subhost: item.sub_host,
          password: this.certPassword,
        }).then((res) => {
          const { data, code, msg } = res || {};
          if (code === 1) {
            this.$message({
              message: item.sub_host + ": " + this.$t("common.success"),
              type: "success",
            });
          } else {
            this.$message({
              message: item.sub_host + ": " + msg,
              type: "error",
            });
          }
        });
      });
      this.showpasswordDiag = false;
      this.refresh();
    },
    commitAddSubdomain() {
      let subhosts = this.selectItems.map((item) => item.sub_host);
      this.subhostsTextarea = subhosts.join(":");
      if (!this.subhostsTextarea) {
        this.$message({
          message: "请选择主域名",
          type: "error",
        });
        return;
      }
      if (!this.upstreamTextarea) {
        this.$message({
          message: "请输入子域名",
          type: "error",
        });
        return;
      }
      // const subhostsArr = this.subhostsTextarea.split('|');
      const newData = upstream_str2list_domain(this.upstreamTextarea);
      addNewChildDomain({ subhosts: subhosts, upstreams: newData }).then(
        (res) => {
          const { code, msg } = res || {};
          if (code === 1) {
            this.$message({
              message: this.$t("common.success"),
              type: "success",
            });
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        }
      );
      this.upstreamTextarea = "";
      this.showAddSubdomainDiag = false;
    },
    batchUpdate(func_name) {
      let para = {
        func: func_name,
        subhosts: this.selectItems.map((item) => item.sub_host),
      };
      if (func_name == "lockHttps") {
        para["lockHttps"] = this.lockHttps;
      } else if (func_name == "defenses") {
        para["isBanEmptyUA"] = this.isBanEmptyUA ? 1 : -1;
        para["jsGuard"] = this.jsGuard ? 2 : 0;
        para["useCaptcha"] = this.useCaptcha ? 1 : -1;
      } else if (func_name == "ssltype") {
        para["ssltype"] = this.ssltype;
      } else if (
        func_name == "upstreams_sets" ||
        func_name == "upstreams_adds"
      ) {
        para["upstreams"] = upstream_str2list(this.upstreamsTextarea);
      } else {
        this.$message({
          message: "unknown func: " + func_name,
          type: "error",
        });
        return;
      }
      apiSubhostBatchEdit(para).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t("common.success"),
            type: "success",
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
        this.showforceRedictDiag = false;
        this.showSetDefenseDiag = false;
        this.showAplyCertDiag = false;
      });
    },
    commitAddRootDomain() {
      if (!this.selectProdId) {
        this.$message({
          message: this.$t('allDomain.tip88'),
          type: "error",
        });
        return;
      }

      if (!this.rootDomaintextarea) {
        this.$message({
          message: this.$t('allDomain.tip99'),
          type: "error",
        });
        return;
      }
      const rootArr =
        (this.rootDomaintextarea && this.rootDomaintextarea.split("|")) || [];
      addMainDomain({ pid: this.selectProdId, subhosts: rootArr }).then(
        (res) => {
          const { code, msg } = res || {};
          if (code === 1) {
            this.showaddRootDomainDiag = false;
            this.getmainDomainList({ page: 1 });
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    add() {
      console.log("add");
      // this.addUseShow = true;
      this.$router.replace("/addUser");
    },
    domainClick(title) {
      const { locale } = this.$i18n;
      const flag = locale === "en_US";
      if (this.selectItems.length == 0) {
        this.$message({
          message: flag
            ? "Please select at least one of Domain Name!"
            : "请至少选择一条域名！",
          type: "error",
        });
        return;
      }

      this.subhosts = this.selectItems.map((item) => item.sub_host);
      this.showOriginDiag = title === 1;
      this.showAplyCertDiag = title == 2;
      this.showforceRedictDiag = title == 3;
      this.showSetDefenseDiag = title == 4;
      this.showcleanCacheDiag = title == 5;
      this.showpasswordDiag = title == 6;
      this.showAddSubdomainDiag = title == 7;
      this.showSubmitCertsDiag = title == 8;
    },
    refresh() {
      this.getmainDomainList({ page: 1 });
    },
    filterClick() {
      this.isFilter = !this.isFilter;
    },
    editClick(item) {
      console.log(item);
    },
    searchClick() {
      let start = "";
      let end = "";
      if (this.createDate && this.createDate.length == 2) {
        start = this.createDate[0];
        end = this.createDate[1];
      }
      this.getmainDomainList({
        page: 1,
        start_date: start,
        end_date: end,
        sub_host: this.searchDomain,
      });
    },
    resetClick() {
      this.searchDomain = "";
      this.$refs.createdate.changeDate("");
    },
    configClick(item) {
      this.clickSelectItem = item;
    },
    tongjiClick(item) {
      console.log("*", item);
    },
    deleteClick(item) {
      this.$prompt(
        this.$t("Login.placeholdPwd"),
        this.$t("allDomain.delete") + item.sub_host,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^.{1,}$/,
          inputErrorMessage: this.$t("Login.placeholdPwd"),
        }
      )
        .then(({ value }) => {
          apiSubhostDelete({
            subhost: item.sub_host,
            password: value,
          }).then((res) => {
            const { data, code, msg } = res || {};
            if (code === 1) {
              this.$message({
                message: this.$t("common.success"),
                type: "success",
              });
              this.getmainDomainList({ page: 1 });
            } else {
              this.$message({
                message: msg,
                type: "error",
              });
            }
          });
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            type: "info",
            message: "cancel",
          });
        });
    },
    switchretictChange(e) {
      console.log(e);
    },
    childDomainClick(item) {
      console.log(item);
      this.$router.push({
        path: "/childDomain",
        query: { sub_host: item.sub_host },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
.users-manage {
  background-color: white;
  padding: 0 24px 24px 24px;
  border-radius: 4px;
  .menu-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
    }
    .menu-right {
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
  }
  .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .search-btn-content {
    display: flex;
    margin-bottom: 49px;
  }
  .user-handle {
    display: flex;
    align-items: center;
    :first-child {
      margin-right: 10px;
      width: 16px;
      height: 16px;
    }
    :last-child {
      width: 18px;
      height: 19px;
    }
  }

  .handle-first {
    display: flex;
    align-items: center;
    :nth-child(1) {
      margin-right: 10px;
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
    :nth-child(2) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(3) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      margin-right: 10px;
      color: #003600;
      cursor: pointer;
    }

    :nth-child(4) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
  }
}
.dialog-content {
  margin-top: -20px;
  .lan-dong {
    margin-top: 28px;
  }
  .btn-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    :first-child {
      padding: 8px 20px;
      background: #336dff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      margin-right: 10px;
    }
    :last-child {
      padding: 8px 20px;
      background: #336dff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      margin-right: 6px;
    }
  }
  .diag-tip {
    margin: 12px 0;
    font-size: 14px;
    color: #666666;
  }
}
.select-my-file {
  width: 100px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
